import { FC } from 'react'

import {
  IconArrowInbox,
  Button,
  SequenceMenu,
  Flex
} from '@sequencehq/core-components'
import { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'
import { useDownloadInvoicePdf, InvoiceMenuItems } from 'Invoices/index'

type Props = {
  invoiceId: string
  invoiceNumber: string | undefined
  invoiceStatus: Dashboardv99990101Api.Invoices.InvoiceStatus
}

export const InvoiceActions: FC<Props> = ({
  invoiceId,
  invoiceNumber,
  invoiceStatus
}) => {
  const { downloadPdf } = useDownloadInvoicePdf()

  return (
    <Flex
      gap="8px"
      alignItems="center"
      width="100%"
      data-testid="watchtower.notification.invoiceEmailFailed.invoiceActions"
    >
      <Button
        variant="secondary"
        style={{ flex: 1 }}
        leadingIcon={<IconArrowInbox color="inherit" />}
        onClick={() => downloadPdf({ invoiceId, invoiceNumber, invoiceStatus })}
        data-testid="watchtower.notification.invoiceEmailFailed.downloadPdf"
      >
        Download PDF
      </Button>
      {invoiceStatus !== 'SENT' && (
        <SequenceMenu
          closeMenuOnItemClick
          alignment="bottom-right"
          data-testid="watchtower.notification.invoiceEmailFailed.kebabMenu"
          items={
            <InvoiceMenuItems.MarkAsSent
              invoiceId={invoiceId}
              invoiceNumber={invoiceNumber}
            />
          }
        />
      )}
    </Flex>
  )
}
